import apiUser from "@/api/apiUser";
import apiAuth from "@/api/apiAuth";

// 오늘이 지정된 날짜 이전 또는 당일인지 확인
function isTodayOnOrBefore(dateValue) {
  const str = String(dateValue);

  const year = Number(str.slice(0, 4));
  const month = Number(str.slice(4, 6)) - 1;
  const day = Number(str.slice(6, 8));

  const endDate = new Date(year, month, day);

  const today = new Date();
  const todayDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  return todayDate <= endDate;
}

// 패키지 금액 기준 권한 계산
function getPackageFlags(userPackage, isCN) {
  console.log('userPackage', userPackage)
  const okLite = Number(userPackage) >= 1000;
  const okPro = Number(userPackage) >= 3000;
  const okPlus = Number(userPackage) >= 5000;
  const okSmart = Number(userPackage) >= 10000;
  console.log('okSmart', okSmart)
  console.log('okPlus', okPlus)
  console.log('okPro', okPro)

  /**
 * 신호등 권한
 *
 * 2026년 8월 30일까지 당일 포함:
 * - 3000 이상이면 가능
 *
 * 2026년 8월 31일부터:
 * - 10000 이상만 가능
 */
  const isLightPromotionPeriod = isTodayOnOrBefore("20260830");
  const isLight = isLightPromotionPeriod ? okPro : okSmart;

  return {
    okLite,
    okPro,
    okPlus,
    okSmart,
    isLight,

    // 중국은 3000 이상이면 Next 가능
    // 중국 제외는 10000 이상이면 Next 가능
    okNext: isCN ? okPro : okSmart,
  };
}

// 알람일자가 있는지 && 기한 안 지났는지 확인 함수
function isDatePassed(dateValue) {
  const str = String(dateValue);

  const year = Number(str.slice(0, 4));
  const month = Number(str.slice(4, 6)) - 1;
  const day = Number(str.slice(6, 8));

  const targetDate = new Date(year, month, day);

  const today = new Date();
  const todayDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  // 종료일자 지났으면 false, 안 지났으면 true
  return targetDate >= todayDate;
}

// 날짜 상관없이 현재 사용하는 권한 체크 함수
export async function chkPermission() {
  const isCN = localStorage.getItem("deviceLang") === "CN"; // 중국인지 아닌지 확인 / next 차트 권한 분리로 인해 필요

  let userPackage = 0; // 유저 패키지 가격 
  let alarmPayment = false;  // 알람 일자 지났는지 여부 
  let permission = false; // 알람구매여부 + 알람종료일자 만료아닌 경우 true / 이외 false
  
  let okLite = false; // 1000 이상
  let okPro = false; // 3000 이상
  let okPlus = false; // 5000 이상
  let okSmart = false; // 10000 이상

  let okNext = false; //중국만 3000 이상 / 이외 10000 이상으로 분리
  let isLight = false; // 260830 까지만 3000 이상 / 이외 10000 이상으로 분리
  let okLight = false; // permission true 인 경우만! 신호등 차트 볼 수 있게 해달라고 해서 변수 생성

  // 패키지 구매건 먼저 호출 이후 패키지 가격 없을 경우 관리자 권한 호출 방식
  try {
    // 관리자에서 권한 준 경우
    const chkForcing = await apiAuth.chkUserPermission();    
    const forcingData = chkForcing?.data || {};
    // console.log('forcingData', forcingData)
    // console.log(222, userPackage)
    // if (forcingData) {
    //   forcingData.endDate = "2027-01-21T00:00:00";
    //   forcingData.isRegistered = true;
    //   forcingData.isSmart = false;
    //   forcingData.isPremium = false;
    //   forcingData.isPayment = true;
    //   forcingData.isLight = true;
    // }

    // console.log('forcingData', forcingData)

    // 알람 종료일자 포맷
    const date =
      forcingData?.endDate
        ?.split("T")[0]
        ?.replaceAll("-", "") ?? null;

    // 종료일자가 존재하고 아직 유효한지
    const hasValidEndDate =
      Boolean(forcingData?.isPayment) &&
      Boolean(forcingData?.endDate) &&
      isDatePassed(date);

    // 관리자 권한으로 패키지가 변경됐는지 여부
    let hasForcingPermission = false;

    /**
     * 신호등 차트 권한
     * isRegistered 여부와 관계없이 적용
     */
    if (hasValidEndDate && forcingData?.isLight) {
      okLight = true;
    }

    if (hasValidEndDate && forcingData?.isLight) {
      userPackage = isTodayOnOrBefore("20260830")
        ? 3000
        : 10000;

      hasForcingPermission = true;
    }

    /**
     * Smart / Premium 강제 권한
     * isRegistered가 true인 경우에만 적용
     */
    const canUseForcing =
      Boolean(forcingData?.isRegistered) &&
      hasValidEndDate;

    if (canUseForcing) {
      if (forcingData?.isSmart) {
        userPackage = 10000;
        hasForcingPermission = true;
      } else if (forcingData?.isPremium) {
        userPackage = 5000;
        hasForcingPermission = true;
      }
    }

    /**
     * 신호등 / Smart / Premium 중
     * 관리자 권한이 하나라도 적용된 경우 공통 처리
     */
    if (hasForcingPermission) {
      const packageFlags = getPackageFlags(userPackage, isCN);

      ({
        okLite,
        okPro,
        okPlus,
        okSmart,
        okNext,
        isLight,
      } = packageFlags);

      alarmPayment = true;
      permission = true;
    }

    // subscribe 호출 / 패키지가격, 차트&알람 시작일자 종료일자 호출 / 패키지 구매했을 경우
    const response = await apiUser.getSubscribe();
    const chkPayment = await apiAuth.getPaymentInfo();

    if (response?.isSuccess) {
      if (response.data.alarmEndDate) {
        alarmPayment = isDatePassed(response.data.alarmEndDate)
        // alarmPayment = isDatePassed('20260702')
      }

      // console.log('11: ', userPackage)
      const packagePrice = Number(response?.data?.packagePrice) || 0;
      // const packagePrice = 10000;
      // console.log('userPackage perrr', userPackage)
      // console.log('packagePrice perrr', packagePrice)


      if (userPackage <= packagePrice) {
        userPackage = packagePrice;
      }

      // console.log('22: ', userPackage)

      permission = alarmPayment && userPackage >= 1000 && chkPayment.data;

      if (permission) {
        const packageFlags = getPackageFlags(userPackage, isCN);
  
        okLite = packageFlags.okLite;
        okPro = packageFlags.okPro;
        okPlus = packageFlags.okPlus;
        okSmart = packageFlags.okSmart;
        okNext = packageFlags.okNext;
        isLight = packageFlags.isLight;
      }

        // okLight =
        //   permission &&
        //   (
        //     isTodayOnOrBefore("20260830")
        //       ? userPackage >= 3000
        //       : userPackage >= 10000
        //   );

        // hasForcingPermission = true;
    }

    // userPackage = 3000;
    // okLite = false;
    // okPro = true;
    // okPlus = false;
    // okSmart = false;
    // okNext = false;
    // alarmPayment = false;
    localStorage.setItem("userPackage", String(userPackage));
    const isLightPromotionPeriod = isTodayOnOrBefore("20260830");
    // console.log('okLight', okLight)

    return {
      okLite, // 1000 이상
      okPro, // 3000 이상
      okPlus, // 5000 이상
      okSmart, // 10000 이상
      okLight, // 신호등 차트는 해당 값으로만 구분 요청으로 해당 값 true 일 때만 접근 가능

      okNext, // 중국: 3000 이상 / 중국 제외: 10000 이상
      isLight, // light 알람 프로모션 기한 동안 권한 
      isLightPromotionPeriod, // light 알람 프로모션 기한 지났는지 안 지났는지 여부

      alarmPayment, // 알람 종료일자 끝났는지 판별 
      permission, // 알람구매여부 + 패키지 1000 이상구매여부
      userPackage, // 패키지 가격
    };
  } catch (error) {
    console.error("chkPermission error:", error);

    const packageFlags = getPackageFlags(userPackage, isCN);

    return {
      permission: false,
      okLite: packageFlags.okLite,
      okPro: packageFlags.okPro,
      okPlus: packageFlags.okPlus,
      okSmart: packageFlags.okSmart,
      okNext: packageFlags.okNext,
      alarmPayment: false,
      userPackage,
      error,
    };
  }
}